import axios from 'axios';
import BaseAPI from './base/base-api';

class DownloadAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'download';

}

export default new DownloadAPI();